let catalog = {
  title: 'Catálogo',
  title_s: 'Catálogo',
  icon: 'mdi-format-list-text',
  print_pdf: 'Salvar PDF / Imprimir',
  print: 'Imprimir',
  pdf: 'Salvar PDF',
  stock: {
    disabled: 'Desabilitado',
    disab: 'Desab.',
    dialog: {
      title: 'Declarar Reposição de Estoque',
      qty: 'Quantidade',
      unit: 'Unitário',
      total: 'Total',
      accept: 'Declarar',
      reject: 'Ignorar'
    }
  }
}

export default catalog
